import { useMemo } from 'react';

import { DeviceType, EPopupSubType, IframePreview } from '@appcharge/shared-ui';

import { cn } from 'components/lib/utils';

export const StorePreview: React.FC<{
  previewProps: React.ComponentProps<typeof IframePreview>;
}> = ({ previewProps }) => {
  const isMobile = useMemo(
    () => previewProps.device === DeviceType.MOBILE,
    [previewProps]
  );

  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-lg relative',
        isMobile
          ? 'mobile-preview w-[420px] h-[90%]'
          : 'desktop-preview w-[100%] h-[100%]'
      )}
      id="store-preview-wrapper"
    >
      <IframePreview
        {...previewProps}
        width={isMobile ? 420 : undefined}
        height="100%"
      />
      {previewProps.displayPopup &&
        previewProps.displayPopupSubType === EPopupSubType.REWARD_CALENDAR && (
          <div className="absolute inset-0 z-10 pointer-events-auto" />
        )}
    </div>
  );
};
